import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-certificate-query',
  templateUrl: './certificate-query.component.html',
  styleUrls: ['./certificate-query.component.scss']
})
export class CertificateQueryComponent {

    @Input() title: string;
    @Input() form: FormGroup;
    @Input() label: string;
    @Input() placeholder: string;
    @Input() controlName: string;
    // Si se setea, se muestra un segundo input "Orden/Falla" obligatorio.
    // Los validators (required + pattern alfanum 7 chars) se setean desde el
    // FormGroup del componente padre. Aqui solo gestionamos render + uppercase
    // automatico para que el lookup contra ref_cita.numero_orden sea predecible.
    @Input() ordenFallaControlName: string = null;
    @Input() ordenFallaLabel: string = 'Orden/Falla';
    @Input() isLoading: boolean = false;
    @Input() showClear: boolean = false;
    @Output() submit = new EventEmitter<void>();
    @Output() clear = new EventEmitter<void>();

    onSubmitClick(): void {
      if (this.form && this.form.invalid) { return; }
      this.submit.emit();
    }

    onClearClick(): void {
      this.clear.emit();
    }

    // Normaliza el "Orden/Falla" a mayusculas y trimmea espacios mientras tipea.
    // Esto evita que el lookup falle por diferencias de case y mantiene
    // consistencia con el regex /^[A-Z0-9]{7}$/ del FormControl.
    onOrdenFallaInput(event: any): void {
      if (!this.form || !this.ordenFallaControlName) { return; }
      const ctrl = this.form.get(this.ordenFallaControlName);
      if (!ctrl) { return; }
      const raw = event && event.target ? event.target.value : '';
      const cleaned = String(raw || '').toUpperCase().replace(/\s+/g, '');
      if (cleaned !== raw) {
        ctrl.setValue(cleaned, { emitEvent: false });
      }
    }
}
